import * as theme from '../../../theme';
import Heading from "../../../components/Heading";
import VideoPlayer from "../../../components/VideoPlayer";
import PDFDisplay from '../../../components/PDFDisplay';
import { useState, useEffect } from 'react';
import { getDocumentUrl } from '../../../functions/storageUtils';

function SupplementReport({ title }) {
  const [documentUrl, setDocumentUrl] = useState('');

  useEffect(() => {
    const fetchUrl = async () => {
      try {
        const url = await getDocumentUrl('Homeopathic Dilution Guidelines', 'private');
        setDocumentUrl(url);
      } catch (error) {
        console.error(error.message);
      }
    };
    fetchUrl();
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 800, width: '100%', position: 'relative', marginLeft: 'auto', marginRight: 'auto' }}>
      <VideoPlayer videoId={title} isPublic={false} />
      <Heading
        title={title}
        subHeading={true}
        center={true}
      />
      <PDFDisplay 
        url={documentUrl}
        description={'Homeopathic Dilution Guidelines - Download this PDF for reference to the dilution ratings to compare if items are Physically Present, Emotionally Manifesting, or Energetically present. You can also find this guide under Resources.'}
      />
    </div>
  );
}

export default SupplementReport;